import ECharts from '~/components/echarts'
import ReactController from '~/controllers/react_controller'

export default class CrowdstrikeDetectionTrendChartController extends ReactController {
  static values = {
    accountIds: Array,
    guardianTiers: Array,
    url: String,
  }

  createComponent() {
    const params = {
      query: {
        account_ids: this.accountIdsValue,
        guardian_tiers: this.guardianTiersValue,
      },
    }

    return (
      <ECharts title={null} url={this.urlValue} params={params} showMaximizeButton={false} showExportButton={false} />
    )
  }
}
